import { styled } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export const Breadcrumbs = styled('nav')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '36px',
  width: '100%',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: 1.5,

  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
    gap: '12px',
  },
}));

export const Link = styled(RouterLink)(({ theme }) => ({
  color: theme.palette.color.fg.unactive,
  transition: 'opacity 0.3s ease-in-out',

  '&:hover': {
    opacity: 0.7,
  },
}));

export const Separator = styled('span')(({ theme }) => ({
  color: theme.palette.color.fg.tetriary,
}));

export const Current = styled('span')(({ theme }) => ({
  color: theme.palette.color.fg.primary,
}));
